import React, { useEffect, useState, useMemo } from "react";
import { FILE_BASE_URL } from "../services/api";
import { getHistory } from "../services/history";

export default function History() {
  const [allHistory, setAllHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchFilters, setSearchFilters] = useState({
    name: ""
  });
  const [selected, setSelected] = useState(null);
  const [showDocuments, setShowDocuments] = useState(false);
  const [preview, setPreview] = useState(null);
  const itemsPerPage = 10;

  // Fetch all history records
  useEffect(() => {
    setLoading(true);
    getHistory({})
      .then(res => setAllHistory(res.data))
      .finally(() => setLoading(false));
  }, []);

  // Filter history based on single quick-search input
  const filteredHistory = useMemo(() => {
    const q = (searchFilters.name || "").trim().toLowerCase();
    if (!q) return allHistory;
    return allHistory.filter(item => {
      return (
        (item.customerId?.fullName || "").toLowerCase().includes(q) ||
        (item.car || "").toLowerCase().includes(q) ||
        (item.regNo || "").toLowerCase().includes(q)
      );
    });
  }, [allHistory, searchFilters]);

  const totalPages = Math.max(1, Math.ceil(filteredHistory.length / itemsPerPage));
  const paginatedHistory = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    return filteredHistory.slice(startIndex, startIndex + itemsPerPage);
  }, [filteredHistory, currentPage]);

  const handleFilterChange = (field, value) => {
    setCurrentPage(1);
    setSearchFilters(prev => ({
      ...prev,
      [field]: value
    }));
  };

  return (
    <div className="customer-wrapper">
      {/* <div className="top-bar">
        <div>
          <h1>History</h1>
          <p>View completed bookings & deal history</p>
        </div>
      </div> */}

      {/* Search Filters Section */}
      {/* Single Quick Search in top bar for a professional, minimal UI */}
      <div className="top-bar" style={{ marginBottom: 18, alignItems: 'center' }}>
        <div>
          <h1>History</h1>
          <p>View completed bookings & deal history</p>
        </div>
        <div style={{ marginLeft: 'auto' }}>
          <input
            type="text"
            placeholder="Quick search by customer, car, or reg. no..."
            value={searchFilters.name}
            onChange={(e) => handleFilterChange('name', e.target.value)}
            style={{
              padding: '10px 14px',
              minWidth: 300,
              borderRadius: 8,
              border: '1px solid #e2e8f0',
              boxShadow: '0 2px 6px rgba(2,6,23,0.04)',
              fontSize: 14,
              outline: 'none'
            }}
            onFocus={(e) => e.target.style.borderColor = '#0ea5e9'}
            onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
          />
        </div>
      </div>
      <div className="card">
        <div className="card-header">
          <h3>Completed Deals</h3>
          <span>{filteredHistory.length} Records{allHistory.length > filteredHistory.length ? ` (filtered from ${allHistory.length})` : ""}</span>
        </div>
        <div className="table-container">
          <table className="pro-table">
            <thead>
              <tr>
                <th>Car</th>
                <th>Customer</th>
                <th>Final Deal Amount</th>
                <th>Expense / Refund</th>
                <th>Total Amount</th>
                <th>Date/Time</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan="7">Loading...</td></tr>
              ) : filteredHistory.length === 0 ? (
                <tr><td colSpan="7" className="empty">{allHistory.length === 0 ? "No completed records found." : "No records match your search criteria."}</td></tr>
              ) : (
                paginatedHistory.map(h => (
                  <tr key={h._id}>
                    <td>{h.car}</td>
                    <td>{h.customerId?.fullName || "-"}</td>
                    <td>₹{h.originalAmount}</td>
                    <td>
                      {Number(h.extraExpenseAmount || 0) !== 0 && (
                        <div style={{ color: "#f97316" }}>₹{Number(h.extraExpenseAmount || 0).toLocaleString("en-IN")}</div>
                      )}

                      {h.otherExpenses && (
                        <div>{h.otherExpenses}</div>
                      )}

                      {(Number(h.refundAmount || 0) !== 0 || h.refundDescription) ? (
                        <div style={{ color: '#ef4444', marginTop: (h.otherExpenses || Number(h.extraExpenseAmount || 0) !== 0) ? 6 : 0 }}>
                          {h.refundDescription ? `${h.refundDescription} ` : 'Refund '}(-₹{Math.abs(Number(h.refundAmount || 0)).toLocaleString("en-IN")})
                        </div>
                      ) : null}

                      {!(Number(h.extraExpenseAmount || 0) !== 0 || h.otherExpenses || Number(h.refundAmount || 0) !== 0 || h.refundDescription) && 'NA'}
                    </td>
                    <td style={{ color: h.refundAmount ? '#ef4444' : 'inherit' }}>₹{h.finalTotalAmount}</td>
                    <td>{new Date(h.createdAt).toLocaleString("en-IN")}</td>
                    <td>
                      <button
                        className="view-btn"
                        onClick={() => setSelected(h)}
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        {!loading && filteredHistory.length > 0 && (
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, padding: "14px 18px 4px" }}>
            <div style={{ color: "#64748b", fontSize: 14 }}>
              Showing {Math.min((currentPage - 1) * itemsPerPage + 1, filteredHistory.length)}-{Math.min(currentPage * itemsPerPage, filteredHistory.length)} of {filteredHistory.length}
            </div>
            <div style={{ display: "flex", gap: 10 }}>
              <button
                type="button"
                onClick={() => setCurrentPage(page => Math.max(1, page - 1))}
                disabled={currentPage === 1}
                style={{
                  padding: "8px 16px",
                  borderRadius: 6,
                  border: "1px solid #cbd5e1",
                  background: currentPage === 1 ? "#f8fafc" : "#fff",
                  color: currentPage === 1 ? "#94a3b8" : "#334155",
                  cursor: currentPage === 1 ? "not-allowed" : "pointer",
                  fontWeight: 600
                }}
              >
                Prev
              </button>
              <div style={{ display: "flex", alignItems: "center", padding: "0 4px", color: "#334155", fontWeight: 600 }}>
                Page {currentPage} of {totalPages}
              </div>
              <button
                type="button"
                onClick={() => setCurrentPage(page => Math.min(totalPages, page + 1))}
                disabled={currentPage === totalPages}
                style={{
                  padding: "8px 16px",
                  borderRadius: 6,
                  border: "1px solid #cbd5e1",
                  background: currentPage === totalPages ? "#f8fafc" : "#fff",
                  color: currentPage === totalPages ? "#94a3b8" : "#334155",
                  cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                  fontWeight: 600
                }}
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>
      {selected && (
        <div className="modal-overlay" style={{ zIndex: 1002, background: "rgba(30,41,59,0.7)" }}>
          <div
            className="modal"
            style={{
              minWidth: 400,
              maxWidth: 480,
              maxHeight: "85vh",
              margin: "60px auto",
              background: "#fff",
              borderRadius: 16,
              boxShadow: "0 8px 32px rgba(30,41,59,0.18)",
              padding: 32,
              position: "relative",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden"
            }}
          >
            {/* Close Button */}
            <button
              onClick={() => setSelected(null)}
              style={{
                position: "absolute",
                top: 18,
                right: 18,
                background: "#f1f5f9",
                border: "none",
                borderRadius: "50%",
                width: 32,
                height: 32,
                fontSize: 20,
                color: "#334155",
                cursor: "pointer"
              }}
              aria-label="Close"
            >
              ×
            </button>
            <h2 style={{ marginBottom: 18, color: "#1e293b", fontWeight: 700, fontSize: 26 }}>Deal Details</h2>

            <div style={{ flex: 1, overflowY: "auto", paddingRight: 8 }}>
              <div style={{
                display: "grid",
                gap: 14,
                marginBottom: 18,
                background: "#f8fafc",
                borderRadius: 12,
                padding: 16,
                boxShadow: "0 1px 4px rgba(30,41,59,0.04)"
              }}>
                <div>
                  <div style={{ fontSize: 12, fontWeight: 700, color: "#64748b", marginBottom: 6, textTransform: "uppercase", letterSpacing: 0.4 }}>Booking</div>
                  <div style={{ display: "grid", gap: 8, fontSize: 15, color: "#1e293b" }}>
                    <div><strong>Car:</strong> {selected.car}</div>
                    <div><strong>Reg. No.:</strong> {selected.regNo}</div>
                    <div><strong>Customer:</strong> {selected.customerId?.fullName || "-"}</div>
                    <div><strong>Phone:</strong> {selected.customerId?.phone || "-"}</div>
                  </div>
                </div>

                <div style={{ borderTop: "1px solid #e2e8f0", paddingTop: 14 }}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: "#64748b", marginBottom: 6, textTransform: "uppercase", letterSpacing: 0.4 }}>Trip</div>
                  <div style={{ display: "grid", gap: 8, fontSize: 15, color: "#1e293b" }}>
                    <div><strong>Pickup:</strong> {selected.pickupDate ? new Date(selected.pickupDate).toLocaleString("en-IN") : "-"}</div>
                    <div><strong>Drop:</strong> {selected.dropDate ? new Date(selected.dropDate).toLocaleString("en-IN") : "-"}</div>
                    <div><strong>Duration:</strong> {selected.totalDays} days ({selected.totalHours} hrs)</div>
                    <div><strong>Per Day Rate:</strong> <span style={{ color: "#0ea5e9" }}>₹{selected.perDayRate}</span></div>
                  </div>
                </div>

                <div style={{ borderTop: "1px solid #e2e8f0", paddingTop: 14 }}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: "#64748b", marginBottom: 6, textTransform: "uppercase", letterSpacing: 0.4 }}>Payment</div>
                  <div style={{ display: "grid", gap: 8, fontSize: 15, color: "#1e293b" }}>
                    <div><strong>Booking Total:</strong> <span style={{ color: "#0ea5e9" }}>₹{Number(selected.originalAmount || 0).toLocaleString("en-IN")}</span></div>
                    <div><strong>Advance Paid:</strong> <span style={{ color: "#22c55e" }}>₹{Number(selected.advanceAmount || 0).toLocaleString("en-IN")}</span></div>
                    <div><strong>Pending at Booking:</strong> <span style={{ color: "#f97316" }}>₹{Number(selected.pendingAmount || selected.originalAmount || 0).toLocaleString("en-IN")}</span></div>
                    {Number(selected.extraExpenseAmount || 0) !== 0 && (
                      <div><strong>Extra Expense Amount:</strong> <span style={{ color: "#f97316" }}>₹{Number(selected.extraExpenseAmount || 0).toLocaleString("en-IN")}</span></div>
                    )}
                    {(Number(selected.refundAmount || 0) !== 0 || selected.refundDescription) && (
                      <div><strong>Refund Amount:</strong> <span style={{ color: "#ef4444" }}>-₹{Math.abs(Number(selected.refundAmount || 0)).toLocaleString("en-IN")}</span></div>
                    )}
                    {selected.otherExpenses && (
                      <div><strong>Other Expenses:</strong> {selected.otherExpenses}</div>
                    )}
                    {selected.refundDescription && (
                      <div><strong>Refund Reason:</strong> <span style={{ color: "#ef4444" }}>{selected.refundDescription}</span></div>
                    )}
                    <div style={{ paddingTop: 8, borderTop: "1px solid #e2e8f0", fontWeight: 700 }}>
                      <strong>Final Amount:</strong> <span style={{ color: selected.refundAmount ? "#ef4444" : "#0ea5e9" }}>₹{Number(selected.finalTotalAmount || 0).toLocaleString("en-IN")}</span>
                    </div>
                  </div>
                </div>

                <div style={{ borderTop: "1px solid #e2e8f0", paddingTop: 14, fontSize: 15, color: "#1e293b" }}>
                  <strong>Date/Time:</strong> {new Date(selected.createdAt).toLocaleString("en-IN")}
                </div>
              </div>

              {/* DOCUMENTS SECTION */}
              {showDocuments && (
                <div style={{
                  marginBottom: 18,
                  background: "#f8fafc",
                  borderRadius: 10,
                  padding: 16,
                  boxShadow: "0 1px 4px rgba(30,41,59,0.04)"
                }}>
                  <h3 style={{ marginBottom: 12, color: "#1e293b", fontSize: 18 }}>Documents</h3>
                  <div style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(100px, 1fr))",
                    gap: 12
                  }}>
                    {[
                      { label: "Aadhar Front", key: "aadharFront" },
                      { label: "Aadhar Back", key: "aadharBack" },
                      { label: "Licence", key: "licence" },
                      { label: "Address Proof", key: "addressProof" }
                    ].map((doc) => {
                      const path = selected.customerId?.documents?.[doc.key];
                      if (!path) return null;

                      const isPDF = path.endsWith(".pdf");
                      const fullUrl = FILE_BASE_URL + "/" + path;

                      return (
                        <div key={doc.key} style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          gap: 8,
                          cursor: "pointer"
                        }}>
                          {isPDF ? (
                            <a
                              href={fullUrl}
                              target="_blank"
                              rel="noreferrer"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "100%",
                                height: 80,
                                background: "#f1f5f9",
                                borderRadius: 8,
                                fontSize: 24,
                                textDecoration: "none"
                              }}
                            >
                              📄
                            </a>
                          ) : (
                            <img
                              src={fullUrl}
                              alt={doc.label}
                              onClick={() => setPreview(fullUrl)}
                              style={{
                                width: "100%",
                                height: 80,
                                borderRadius: 8,
                                objectFit: "cover",
                                cursor: "pointer",
                                border: "1px solid #e2e8f0"
                              }}
                            />
                          )}
                          <span style={{ fontSize: 12, color: "#64748b", textAlign: "center" }}>
                            {doc.label}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end", gap: 12, marginTop: 18 }}>
              <button
                type="button"
                onClick={() => setShowDocuments(!showDocuments)}
                style={{
                  padding: "8px 22px",
                  background: "#3b82f6",
                  color: "#fff",
                  border: "none",
                  borderRadius: 6,
                  fontWeight: 600,
                  fontSize: 15,
                  cursor: "pointer"
                }}
              >
                {showDocuments ? "Hide Documents" : "Show Documents"}
              </button>
              <button
                type="button"
                onClick={() => setSelected(null)}
                style={{
                  padding: "8px 22px",
                  background: "#f1f5f9",
                  color: "#334155",
                  border: "none",
                  borderRadius: 6,
                  fontWeight: 600,
                  fontSize: 15,
                  cursor: "pointer"
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* PREVIEW IMAGE MODAL */}
      {preview && (
        <div
          className="modal-overlay"
          style={{
            zIndex: 2000,
            background: "rgba(0, 0, 0, 0.95)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer"
          }}
          onClick={() => setPreview(null)}
        >
          <img
            src={preview}
            alt="Full preview"
            style={{
              maxWidth: "90%",
              maxHeight: "90vh",
              borderRadius: 8,
              boxShadow: "0 20px 60px rgba(0, 0, 0, 0.5)"
            }}
            onClick={e => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
}
